import React from 'react';
import { Box } from '../../components/UI-CHAKRA/Box';
import { Button } from '../../components/UI-CHAKRA/Button';
import { Text } from '../../components/UI-CHAKRA/Text';
import { Flex } from '../../components/UI-CHAKRA/Flex';
import BaseDialog from '../../components/Dialogs/BaseDialog';

interface WhatsAppDialogConsentProps {
  showWhatsAppDialogConsent: boolean;
  onCancel(): void;
  onConfirm(): void;
}

function WhatsAppDialogConsent(props: WhatsAppDialogConsentProps) {
  return (
    <BaseDialog isOpen={props.showWhatsAppDialogConsent} onClose={props.onCancel}>
      <div id={'whatsappconsent'} style={{ marginTop: '24px', marginBottom: '40px' }}>
        <Text fontSize={'18px'} fontWeight={700} color={'#343A40'}>
          Aviso Importante
        </Text>

        <Box padding={'0 24px'}>
          <Box marginBottom={'10px'}>
            <Text fontSize={'16px'} fontWeight={500} color={'#343A40'}>
              Ao utilizar o envio pelo WhatsApp você entende que:
            </Text>
          </Box>

          <Flex style={{ marginBottom: '10px' }}>
            <Box style={{ width: '10px', marginRight: '10px' }}>
              <Text fontSize={'14px'} fontWeight={400} color={'#343A40'}>
                1
              </Text>
            </Box>
            <Box style={{ width: '324px' }}>
              <Text fontSize={'14px'} fontWeight={400} color={'#343A40'}>
                É sua responsabilidade solicitar ao paciente a autorização para o envio da prescrição pelo WhatsApp.
              </Text>
            </Box>
          </Flex>

          <Flex>
            <Box style={{ width: '10px', marginRight: '10px' }}>
              <Text fontSize={'14px'} fontWeight={'400'} color={'#343A40'}>
                2
              </Text>
            </Box>
            <Box style={{ width: '324px' }}>
              <Text fontSize={'14px'} fontWeight={400} color={'#343A40'}>
                Você precisa estar logado em sua conta do WhatsApp Web. O correto uso dessa ferramenta é sua exclusiva
                responsabilidade.
              </Text>
            </Box>
          </Flex>
        </Box>
      </div>

      <Flex padding={'0 24px'} gap={'12px'} justifyContent={'flex-end'}>
        <Button
          w={'120px'}
          h={'40px'}
          onClick={props.onCancel}
          variant={'ghost'}
          bg={'gray.lightest'}
          color={'typography.darkest'}
          boxShadow={'none'}
          fontWeight={400}
          fontSize={'14px'}
        >
          Não concordo
        </Button>

        <Button
          w={'120px'}
          h={'40px'}
          onClick={props.onConfirm}
          variant={'ghost'}
          backgroundColor={'info.main'}
          color={'#fff'}
        >
          Concordo
        </Button>
      </Flex>
    </BaseDialog>
  );
}

export default WhatsAppDialogConsent;
